module.exports = __webpack_public_path__ + "img/white gb Icon@4x.4b81c4e8.png";